import { join } from "ramda";
import * as React from "react";
import { formatMoneyValue } from "../../utils/formatters";
import "./PersistentAccountingFormula.scss";

interface PersistentAccountingFormulaColumnProps {
  header: string;
  value: number | undefined;
  isDifference?: boolean;
  exceptionString?: string;
}

const valueString = (contents: number | undefined): string | undefined => {
  return contents === undefined ? contents : formatMoneyValue(contents);
};

const valueCell = (contents: number | undefined, extraStyle?: string) => {
  const style = join(" ", ["PersistentAccountingFormula__value", extraStyle]);

  if (contents && contents < 0) {
    return <div className={style}>({valueString(Math.abs(contents))})</div>;
  } else {
    return <div className={style}>{valueString(contents)}</div>;
  }
};

const differenceValueCell = (contents: number | undefined) => {
  return valueCell(
    contents,
    contents === 0 ? "" : "PersistentAccountingFormula__error"
  );
};
const getValue = (value, isDifference, exceptionsString) => {
  if (exceptionsString) {
    return (
      <div className="PersistentAccountingFormula__error">
        {exceptionsString}
      </div>
    );
  }
  return isDifference ? differenceValueCell(value) : valueCell(value);
};

const PAFColumn: React.SFC<PersistentAccountingFormulaColumnProps> = ({
  header,
  value,
  isDifference,
  exceptionString
}) => (
  <div className="PersistentAccountingFormula__column">
    <div className="PersistentAccountingFormula__header">{header}</div>
    {getValue(value, isDifference, exceptionString)}
  </div>
);

export default PAFColumn;



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/PAFColumn.tsx